import {
    REQUIRED_FOR_SELF_SERVICE_CONFIG_PROPERTY_NAME
} from "@constants/oidc-login-hint";
import { RpServiceAttributeProperty } from "@idw-types/data/reference-data/generic";

export const groupServiceAttributeProperties = (serviceAttributeProperties: Array<RpServiceAttributeProperty>) => {
    let numberOfFields = 0;
    let numberOfRows = 0;

    const attributeProperties: Array<{ properties: Array<RpServiceAttributeProperty>; }> = [];

    serviceAttributeProperties.filter(sap => sap.type !== "Text").forEach(sap => {
        if (numberOfFields % 2 == 0) {
            attributeProperties.push({ properties: [sap] });
        } else {
            if (attributeProperties[numberOfRows]) {
                attributeProperties[numberOfRows].properties.push(sap)
            } else {
                attributeProperties.push({ properties: [sap] });
            }
            numberOfRows++;
        }
        numberOfFields++;
    });

    serviceAttributeProperties.filter(sap => sap.type === "Text").forEach(sap => {
        attributeProperties.push({ properties: [sap] });
        numberOfRows++;
    })

    return attributeProperties;
};

export const getFilteredServiceAttributes = (serviceAttributeProperties: Array<RpServiceAttributeProperty>, isSelfServiceConfigured: boolean) => {
    return serviceAttributeProperties.filter(
        sap => sap.name !== REQUIRED_FOR_SELF_SERVICE_CONFIG_PROPERTY_NAME
            || (sap.name === REQUIRED_FOR_SELF_SERVICE_CONFIG_PROPERTY_NAME && isSelfServiceConfigured));
};